module.exports = __webpack_public_path__ + "media/images/athletes/206-bb829e65c657abea271a5ee768162ec2.png";